import { useEffect, useState } from "react";
import { Dispatch } from "redux";
import { DEFAULT_FUSE_NUMBER } from "~/constants/config/common";
import clientSide from "~/helpers/clientSide";
import { getSiteKey } from "~/helpers/site";
import { setTrackingCustomAttributes, setNewRelicCustomAttribute, setNewRelicPageAction } from "~/helpers/newrelic";
import { formatPhone } from "~/helpers/phone";
import { setTracking } from "~/redux/actions/common";
import Cookies from "js-cookie";
import LogRocket from "logrocket";
import { KoreDataType } from "~/hooks/chatbot/helpers";
type Tracking = {
  [key: string]: string;
};
declare global {
  export interface Window {
    _Cohesion: {
      anonymousId: string;
      sessionId: string;
      webContext: {
        userAgent: string;
        page: {
          referrer: string;
        };
      };
      tenantId: string;
    };
    _Monarch: {
      evaluations?: {
        source?: {
          source?: {
            cartShowGigachat?: {
              value?: boolean;
            };
            cartGigachatSdkVersion?: {
              value?: string;
            };
            trafficFlow?: {
              value?: {
                experienceNumber?: string;
              };
            };
            blockedSessions?: {
              value?: boolean;
            };
          };
        };
      };
    };
    KOREDATA: KoreDataType;
    fuse: (meta: string, data: Record<string, unknown>) => void;
  }
}
interface UseCohesionReturn {
  fuseNumber: string | null;
}
const useCohesion = (dispatch: Dispatch, tracking: Tracking): UseCohesionReturn => {
  const site = getSiteKey();
  const defaultFuseNumber = DEFAULT_FUSE_NUMBER[site] || "";
  const [fuseNumber, setFuseNumber] = useState<string | null>(null);
  useEffect(() => {
    if (clientSide) {
      window?.cohesion("ready", () => {
        const {
          anonymousId,
          sessionId,
          webContext,
          tenantId
        } = window?._Cohesion;
        const experienceNumber = window?._Monarch?.evaluations?.source?.source?.trafficFlow?.value?.experienceNumber;
        LogRocket.identify(sessionId);
        LogRocket.track("custom_tracking", {
          cart_site: `Fuel Cart - ${getSiteKey()}`,
          clientSessionId: tracking.clientSessionId,
          experienceNumber: experienceNumber,
          domain_str: window?.location.hostname,
          releaseTag_str: process.env.release
        });
        dispatch(setTracking("anonymousId", anonymousId));
        dispatch(setTracking("sessionId", sessionId));
        dispatch(setTracking("tenantId", tenantId));
        dispatch(setTracking("referrer", webContext.page.referrer));
        dispatch(setTracking("userAgent", webContext.userAgent));
        setTrackingCustomAttributes(tracking, true);
      });
      window?.cohesion("fuse:leasesReceived", leases => {
        const amex = Cookies.get("isAmexOffer") === "true";
        if (!amex) {
          if (leases[0]?.dnis) {
            setFuseNumber(formatPhone(leases[0].dnis));
          } else {
            setFuseNumber(defaultFuseNumber);
          }
        }
      });
      window?.cohesion("fuse:error", err => {
        setFuseNumber(defaultFuseNumber);
        setNewRelicCustomAttribute([{
          name: "FuseError",
          value: err
        }]);
        setNewRelicPageAction("fuse:error");
      });
    }
  }, []);
  return {
    fuseNumber
  };
};
export default useCohesion;